<div>
	<p-table
		#mydt
		[value]="lstFacilityLocation"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedFacilityLocation"
		dataKey="FacilityLocationID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--FacilityLocationName-->
				<th>
					<p-columnFilter type="text" field="FacilityLocationName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FacilityName-->
				<th>
					<p-columnFilter field="FacilityName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterFacilityName
								[ngModel]="value"
								[options]="lstFacilityName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ScanCount-->
				<th>
					<!-- <p-columnFilter type="text" field="ScanCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="FacilityLocationName">Location<p-sortIcon field="FacilityLocationName"></p-sortIcon></th>
				<th pSortableColumn="FacilityName">Facility<p-sortIcon field="FacilityName"></p-sortIcon></th>
				<th pSortableColumn="ScanCount">Scan Count<p-sortIcon field="ScanCount"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-FacilityLocation>
			<tr [pSelectableRow]="FacilityLocation">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ FacilityLocation[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
